import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert
} from '@mui/material';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import LogoUploader from './logoUploader';
import * as Constant from 'common/Constant';
import SubmitButton from 'common/SingleClickButton';

const getDialogTitle = (target) => {
  if (!target) return 'Logo';
  if (target.TYPE === Constant.LOGO_DEFAULT_TYPE) return 'Default Logo';
  if (target.TYPE === Constant.LOGO_BROKER_LOGO) return 'Broker Logo';
  return 'Tenant Logo';
};

const LogoUploaderDialog = (props) => {
  const { onClose, open, target } = props;

  const methods = useForm({ defaultValues: target, mode: 'onBlur' });
  const { reset, formState, watch } = methods;
  const lightLogo = watch('lightLogoFile');
  const darkLogo = watch('darkLogoFile');

  const validationErrorMsg = (!lightLogo && !darkLogo) ? 'Upload at least one logo before saving.' : '';

  const handleClose = (data) => {
    onClose(data);
  };

  const onSubmit = (data) => {
    onClose(data);
  };

  useEffect(() => {
    reset(target);
  }, [open, target]);
  return (
    <>
      <FormProvider {...methods}>
        <Dialog
          open={open}
          onClose={(_, reason) => {
            if (reason !== 'backdropClick') {
              handleClose();
            }
          }}>
          <DialogTitle id="customized-dialog-title">
            {getDialogTitle(target)}
          </DialogTitle>
          <DialogContent dividers>
            <LogoUploader />
            {!!validationErrorMsg && (
              <Alert severity="warning" sx={{ mt: '16px' }}>
                {validationErrorMsg}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <SubmitButton
              handleSubmit={methods.handleSubmit(onSubmit)}
              isDirty={formState.isDirty && (lightLogo || darkLogo)}
            />
            <Button onClick={() => handleClose(null)} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default LogoUploaderDialog;
